<template>
    <label :id="id + '-component'" class="mdc-text-field mdc-text-field--outlined save-search-input">
        <span class="mdc-notched-outline mdc-input-decorations">
            <span class="mdc-notched-outline__leading"></span>
            <span class="mdc-notched-outline__notch notch">
            <span class="mdc-floating-label" :id="id"> {{label}} </span>
            </span>
            <span class="mdc-notched-outline__trailing"></span>
        </span>
        <input
        v-model="input_value"
        type="text"
        class="mdc-text-field__input"
        :aria-labelledby="id">
    </label>
</template>
<script>
    import {MDCTextField} from '@material/textfield';
    export default {
        name: 'SaveSearchInput',
        data() {
            return {
                input_value: '',
                text_field: null,
            };
        },
        props: {
            id: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: true
            }
        },
        watch: {
            input_value(new_val, old_val) {
                const max_size = 15;
                const new_val_is_valid = /^[a-zA-Z0-9\s_\\-]*$/.test(new_val) && new_val.length <= max_size && !/\s{2,}/.test(new_val);
                if(new_val_is_valid) {
                    this.showError = false;
                    this.$emit('inputChanged', new_val);
                }
                else {
                    this.input_value = old_val;
                    this.showError = true;
                }
            }
        },
        mounted() {
            this.text_field = new MDCTextField(document.querySelector('#' + this.id + '-component'));
            this.text_field.focus();
        },
        methods: {

        }
  }
</script>
<style lang="scss" scoped>
@use "@material/floating-label/mdc-floating-label";
@use "@material/line-ripple/mdc-line-ripple";
@use "@material/notched-outline/mdc-notched-outline";
@use "@material/textfield";
@include textfield.core-styles;

.save-search-input {
    --savesearchinput-border-width: 1px;
    --savesearchinput-border-color: rgba(0, 0, 0, 0.1);
}

.save-search-input.mdc-text-field {
    @include textfield.disabled-fill-color(#F3F4F7);
    @include textfield.ink-color(var(--color-custom-filter-inputs-font-color));
    @include textfield.label-color(var(--color-custom-filter-inputs-font-color)); //color del label que esta en el input y que luego se pone arriba
    @include textfield.placeholder-color(rgba(0, 0, 0, 0.6));
    @include textfield.disabled-ink-color(rgba(0, 0, 0, 0.6));
    @include textfield.outline-color(#c7c8cc);//color del borde cuando no esta seleccionado
    @include textfield.outlined-height(50px, 50px);
    //@include textfield.fill-color(var(--color-background-background-casillas));
    --mdc-theme-primary: rgba(0, 0, 0, 0.6); //con esta linea cambiamos el borde del input cuando esta seleccionado.
    @include textfield.hover-outline-color(#343948);
    @include textfield.focused-outline-color(#343948);
}

.save-search-input .mdc-input-decorations > span {
    border-width: var(--savesearchinput-border-width) !important;
    //background-color: var() !important;
}

.save-search-input .mdc-input-decorations .notch {
    border-left: none !important;
    border-right: none !important;
}

.save-search-input input {
    z-index: 5;
}

.save-search-input .mdc-text-field-helper-text {
    border-color: red;
    --mdc-theme-error: red;
}

</style>